import { Stack } from '@mui/material'
import { useSnackbar } from 'notistack'
import { useState } from 'react'
import axiosClient from 'utils/axiosClient'
import DialogConfirm from './Dialog'

interface Props {
  open: boolean
  apiEndpoint: string
  children: React.ReactNode
  handleClose: () => void
  handleFinal?: () => void
}

export default function DeleteDialog({
  open,
  apiEndpoint,
  children,
  handleClose,
  handleFinal = () => {},
}: Props) {
  const { enqueueSnackbar } = useSnackbar()
  const [loading, setLoading] = useState(false)
  const onSubmit = async () => {
    try {
      setLoading(true)
      await axiosClient.delete(apiEndpoint)
      enqueueSnackbar('削除が完了しました。', {
        variant: 'success',
      })
    } catch (error) {
      enqueueSnackbar('エラーが発生しました。', {
        variant: 'error',
      })
    } finally {
      setLoading(false)
      handleClose()
      handleFinal()
    }
  }
  return (
    <DialogConfirm
      open={open}
      loading={loading}
      handleClose={handleClose}
      handleSubmit={onSubmit}
      maxWidth="xs"
      title={'削除確認'}
      primaryButtonColor="secondary"
      primaryButtonText="削除する"
      bodyMinHeight={50}
    >
      <Stack direction="row" justifyContent="center">
        {children}
      </Stack>
    </DialogConfirm>
  )
}
